import { HelpOutline } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import { Info } from "assets/img/svg/info";
import type { CSSProperties } from "react";

import variables from "../../../assets/styles/_variables.module.scss";
import styles from "./style.module.scss";

const InfoTooltip = ({
    text = "",
    link,
    iconType = "info",
    color,
    style,
}: {
    text: string | undefined;
    link?: string;
    iconType?: "info" | "question";
    color?: string;
    style?: CSSProperties;
}) => {
    return (
        <Tooltip title={text ?? ""} className={styles["info-tooltip"]} arrow>
            <a href={link} target="_blank" rel="noreferrer">
                {iconType === "info" ? (
                    <Info color={color ?? variables["info"]} style={style} />
                ) : (
                    <HelpOutline style={{ color: color ?? variables["info"], ...style }} />
                )}
            </a>
        </Tooltip>
    );
};

export default InfoTooltip;
